import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {Panel, PanelCheckbox, CheckboxWithLabel, ObjectSelect2, FormLayout, NumberInput} from 'shared/components';
import {FormattedMessage} from 'react-intl';

const LieuTime = observer(({uiState}) => {
  const {policy, errors, bankRegularHoursEnabled, bankOvertimeEnabled, doubleOvertimeEnabled, overtimeStandard} = uiState;

  return (
    <div>
      <Panel.Header
        title={t('time_tracking.manage.policies.edit.steps.Lieu Time')}
        description={t('time_tracking.manage.policies.edit.lieu_time.Choose which hours should be banked as lieu time and at what rate.')}
      />
      <CheckboxWithLabel
        label='time_tracking.manage.policies.edit.lieu_time.Enable Lieu Time'
        checked={policy.lieuTimeEnabled}
        onChange={e => uiState.setLieuTimeEnabled(e.checked)}
      />
      <div style={{marginLeft: '24px'}} className='jumbo mb2'>
        <FormattedMessage id='time_tracking.manage.policies.edit.lieu_time.Bank eligible hours as lieu time instead of paying them out.'/>
      </div>
      {policy.lieuTimeEnabled &&
        <FormLayout>
          <ObjectSelect2
            label='time_tracking.manage.policies.edit.lieu_time.Add banked time to'
            value={policy.lieuTimePTOType}
            onChange={value => policy.merge({lieuTimePTOType: value})}
            items={uiState.timeOffTypes}
            errorMessage={errors.lieuTimePTOTypeId}
          />
          <hr className='my3'/>
          <div className='h3 medium mb2'>
            <FormattedMessage id='time_tracking.manage.policies.edit.lieu_time.What can be banked?'/>
          </div>
          <PanelCheckbox
            className='mb2'
            label='time_tracking.manage.policies.edit.lieu_time.Regular hours'
            description='time_tracking.manage.policies.edit.lieu_time.Bank some regular hours as lieu time.'
            checked={bankRegularHoursEnabled}
            onChange={e => uiState.toggleBankRegularHours(e.checked)}
          >
            <NumberInput
              label='time_tracking.manage.policies.edit.lieu_time.Weekly threshold'
              max={168}
              min={0}
              value={policy.lieuTimeWeeklyThreshold}
              onChange={e => policy.merge({lieuTimeWeeklyThreshold: e.target.value})}
              errorMessage={errors.lieuTimeWeeklyThreshold}
              connectedRight={
                <div className='InputGroup'>
                  <span className='InputGroup-tag small'>{t('time_tracking.manage.policies.edit.hours')}</span>
                </div>
              }
            />
          </PanelCheckbox>
          <PanelCheckbox
            label='time_tracking.manage.policies.edit.lieu_time.Overtime hours'
            description='time_tracking.manage.policies.edit.lieu_time.Bank all overtime as lieu time.'
            checked={bankOvertimeEnabled}
            onChange={e => uiState.toggleBankOvertime(e.checked)}
            disabled={policy.overtimePolicy === 'exempt'}
          >
            <FormLayout.Group>
              <NumberInput
                label='time_tracking.manage.policies.edit.Overtime multiplier'
                min={0}
                value={policy.lieuTimeMultiplier}
                onChange={e => policy.merge({lieuTimeMultiplier: e.target.value})}
                errorMessage={errors.lieuTimeMultiplier}
              />
              {(doubleOvertimeEnabled || overtimeStandard) && <NumberInput
                label='time_tracking.manage.policies.edit.Double overtime multiplier'
                min={0}
                value={policy.lieuTimeDoubleMultiplier}
                onChange={e => policy.merge({lieuTimeDoubleMultiplier: e.target.value})}
                errorMessage={errors.lieuTimeDoubleMultiplier}
              />}
            </FormLayout.Group>
          </PanelCheckbox>
        </FormLayout>
      }
    </div>
  );
});

export default LieuTime;
